import { TreeViewDataItem } from "./DocumentPartTree";
import { DocumentPartWithStatus } from "../../api/models/document-part-with-status";
import { UserDocumentCheckout } from "../../api/models/user-document-checkout";
import { IContextualMenuProps } from "@fluentui/react";
import React, { Dispatch, SetStateAction } from "react";
import { DocumentRoot } from "../../api/models/document-root";
import { UserApprover } from "../../api/models/user-approver";
import { DocumentPartWithSuperUser } from "../../api/models/document-part-with-super-user";
import { getWorkflowStatus } from "./DocumentPartTreeUtils";
import { getWorkflowCategory, OutlineFilterStatus } from "./workflowStatusCategory";

export interface TreeItemRowProps {
  item: TreeViewDataItem;
  itemHierarchicalIndex: string;
  isSelected: boolean;
  isDraggable?: boolean;
  getIconButtonMenuProps?: (
    item: any,
    itemHierarchicalIndex: string,
    documentPartWhithStatus: DocumentPartWithStatus[]
  ) => IContextualMenuProps;
  onClick?: React.MouseEventHandler;
  onDocumentNameChange?: (item: TreeViewDataItem, newName: string | undefined) => void;
  hasReadPermissions?: boolean;
  onChangePage?: (key: string, page: string) => React.MouseEventHandler;
  fetchExpandedNode?: (id: string, isReload: boolean, page: number) => void;
  isLinkExisting?: boolean;
  certificationOptions?: (item: TreeViewDataItem) => IContextualMenuProps;
  isOutlineRibbon?: boolean;
  isOpenOutlineRibbon?: boolean;
  azureDefaultSite?: string;
  setSelectedItem?: (item: TreeViewDataItem) => void;
  elementToUpdate?: Dispatch<SetStateAction<DocumentRoot[]>>;
  documentPartWithStatus?: DocumentPartWithStatus[];
  onFetchComplete?: (key: string, map: UserApprover) => void;
  onFetchCompleteForSuperUser?: (key: string, map: DocumentPartWithSuperUser) => void;
  setDocumentPartWithStatus?: (documentPartWhithStatus: DocumentPartWithStatus) => void;
  onMenuWillOpen?: (item: TreeViewDataItem) => Promise<void>;
  pathInfo?: {
    setPathForItem: (itemId: string, path: string) => void;
    getPathForItem: (itemId: string) => string;
  };
}
export function iconCertification(
  item: TreeViewDataItem,
  documentPartWithStatus: DocumentPartWithStatus[],
  allUserDocumentCheckouts: UserDocumentCheckout[]
) {
  const itemState = getWorkflowStatus(item.key, documentPartWithStatus);
  const isAnyDocumentCheckout: boolean =
    allUserDocumentCheckouts?.length > 0 &&
    allUserDocumentCheckouts?.find(
      (userDocumentCheckout: UserDocumentCheckout) => userDocumentCheckout.documentId === item.key
    ) !== undefined;

  if (itemState == null) {
    return "loading_status";
  }
  switch (getWorkflowCategory(itemState)) {
    case OutlineFilterStatus.NOT_RELEVANT:
      return "ms-significant_icon";
    case OutlineFilterStatus.IN_PROGRESS:
      return "ms-in_progress_icon";
    case OutlineFilterStatus.TO_BE_APPROVED:
      return isAnyDocumentCheckout ? "ms-locked_document_white" : "ms-pending_withpermission_icon";
    case OutlineFilterStatus.PENDING_APPROVAL:
      return isAnyDocumentCheckout ? "ms-locked_document_blu" : "ms-pending_withoutpermission_icon";
    case OutlineFilterStatus.REJECTED:
      return "ms-rejection_icon";
    case OutlineFilterStatus.SUBMITTED:
      return "ms-submission_icon";
    default:
      return "ms-initial_state_icon";
  }
}

export function iconClassName(item: TreeViewDataItem) {
  if (item.nodeType == "pagination") return;
  if (item.nodeType == "section") return "k-icon k-i-excel";
  return "k-icon k-i-word";
}
